export enum ButtonType {
	primary = "primary",
	secondary = "secondary",
}

export enum ButtonSubType {
	linkIcon = "-link-icon",
	link = "-link",
	outline = "-outline",
}

export enum ButtonState {
	default = "default",
	active = "active",
	disabled = "disabled",
}

export interface IconProperties {
	iconName: TIconType;
	fill?: string;
	strokeWidth?: number;
	iconClasses?: string[];
	isActive?: string;
}
